import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import Header from "../components/Header";
import PortalBack from "../components/PortalBack";
import api from "../lib/api";

export default function LeverageDetail() {
  const { id } = useParams();
  const [l, setL] = useState(null);
  useEffect(() => { api.get(`/list/leverage/${id}`).then((r) => setL(r.data)).catch(() => setL(false)); }, [id]);
  if (l === false) return <div className="min-h-screen bg-obsidian text-ivory pt-32 px-6"><PortalBack /><p className="mt-6">This link is no longer available.</p></div>;
  if (!l || !l.target_profile) return <div className="min-h-screen bg-obsidian" />;
  const p = l.target_profile;

  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      <Header variant="list" active="list" />
      <section className="pt-28 pb-14 px-6 lg:px-10 max-w-5xl mx-auto">
        <PortalBack label="Back to Leverage Links" />
        <div className="mt-8 flex items-center gap-6">
          <span className="font-display text-5xl text-gold whitespace-nowrap" data-testid="leverage-score">{l.score}<span className="text-xl text-gold/70">/100</span></span>
          <div><p className="eyebrow mb-2">Leverage score · Potential</p><h1 className="font-display text-3xl lg:text-4xl tracking-tight">{p.name}</h1><p className="text-sm text-ivory/50 mt-1">{p.role} · {p.location}</p></div>
        </div>

        <div className="mt-10 border-l-2 border-aqua pl-5">
          <p className="eyebrow !text-aqua mb-1">The Leak</p>
          <p className="font-headline text-2xl">{l.leak}</p>
        </div>

        <div className="mt-10 grid gap-px bg-gold/20 border border-gold/20">
          {[
            { t: "Why They Are Relevant", v: l.why },
            { t: "The Opportunity", v: l.opportunity },
            { t: "Value For You", v: l.value_a },
            { t: `Value For ${p.name.split(" ")[0]}`, v: l.value_b },
          ].map((row) => (
            <div key={row.t} className="bg-obsidian p-6"><p className="eyebrow mb-2">{row.t}</p><p className="text-ivory/80 leading-relaxed">{row.v}</p></div>
          ))}
        </div>

        <div className="mt-10 border border-gold/30 p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
          <div><p className="eyebrow mb-2">Suggested Next Action</p><p className="font-headline text-xl max-w-lg">{l.next_action}</p></div>
          <button data-testid="initiate-intro-btn" onClick={() => toast.success("Private introduction requested. Lola will prepare the outreach.")}
            className="btn-lux bg-gold text-obsidian hover:bg-ivory whitespace-nowrap">Initiate Private Intro</button>
        </div>
      </section>
    </div>
  );
}
